import { render } from "./AxertaChat.vue?vue&type=template&id=3ed5b448&scoped=true"
import script from "./AxertaChat.vue?vue&type=script&lang=js"
export * from "./AxertaChat.vue?vue&type=script&lang=js"

import "./AxertaChat.vue?vue&type=style&index=0&id=3ed5b448&scoped=true&lang=css"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed5b448"]])

export default __exports__